var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGettingStartedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3.66663H17C17.5304 3.66663 18.0391 3.85978 18.4142 4.2036C18.7893 4.54741 19 5.01373 19 5.49996V16.5C19 16.9862 18.7893 17.4525 18.4142 17.7963C18.0391 18.1401 17.5304 18.3333 17 18.3333H6C5.73478 18.3333 5.48043 18.2367 5.29289 18.0648C5.10536 17.8929 5 17.6597 5 17.4166V4.58329C5 4.34018 5.10536 4.10702 5.29289 3.93511C5.48043 3.7632 5.73478 3.66663 6 3.66663M9 3.66663V20.1666",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.33337H15",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11H15",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGettingStartedWhite);
export default __webpack_public_path__ + "static/media/Icon_GettingStarted_White.fe5414a2835ee70234b0449bbeecd21e.svg";
export { ForwardRef as ReactComponent };